import React from 'react'

class Image extends React.Component {
  state = {
    loaded: true
  }

  componentDidMount() {
    if (!this.image.complete) this.setState({ loaded: false})
  }

  onLoad = () => {
    this.setState({ loaded: true })
  }

  setImage = el => {
    this.image = el
  }

  render() {
    const style = { opacity: this.state.loaded ? '' : 0 }

    return (
      <img {...this.props} style={style} onLoad={this.onLoad} ref={this.setImage} />
    )
  }
}

export default Image



// WEBPACK FOOTER //
// ./src/components/Image.js